import React from 'react';
import './ProfileHero.css';

const initials = (name='', lastname='') =>
  `${name[0]||''}${lastname[0]||''}`.toUpperCase() || '?';

const roleColor = (role) =>
  role === 'superadmin' ? '#be1622' : role === 'admin' ? '#10b981' : '#10b981';

const ProfileHero = ({ profile }) => (
  <div className="ph-hero">
    <div className="ph-bg" />
    <div className="ph-avatar">
      {initials(profile?.name, profile?.lastname)}
    </div>
    <div className="ph-info">
      <h2 className="ph-fullname">{profile?.name} {profile?.lastname}</h2>
      <span className="ph-role" style={{ background: roleColor(profile?.role) }}>
        {profile?.role}
      </span>
    </div>
  </div>
);

export default ProfileHero;